//all persian letters
export default function onlyPersianLetter(letter: string) {
    if (letter === '') return true;
    const pattern = /^[\u0600-\u06FF\uFB8A\u067E\u0686\u06AF\u200C\u200F ]+$/g;
    return pattern.test(letter);
}
